const stages = [
  { icon: "ri-shopping-basket-line", title: "Malzeme", desc: "Taze ve özenle seçilen malzemeler." },
  { icon: "ri-knife-line", title: "Hazırlık", desc: "Titizlikle yapılan ön hazırlık." },
  { icon: "ri-fire-line", title: "Günlük Pişirme", desc: "Aynı gün, taze pişirme." },
  { icon: "ri-truck-line", title: "Teslimat", desc: "Planlanan saatte sıcak teslim." },
];

export default function FarmToTable() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            MUTFAKTAN ÇIKTIĞI GİBİ,
            <br />
            SOFRANA ULAŞSIN.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stages.map((stage, i) => (
            <div key={stage.title} className="relative">
              <div className="bg-background-100 border border-background-200 rounded-lg p-7 text-center h-full">
                <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 text-accent-900 flex items-center justify-center">
                  <i className={`${stage.icon} text-3xl`}></i>
                </div>
                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
                  {stage.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600">{stage.desc}</p>
              </div>
              {i < stages.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full items-center justify-center z-10">
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}